let React =                   require("react");

let PaginationDataComponent = require("./PaginationDataComponent.jsx");
let LoadingPlaceholder =      require("./cards/LoadingPlaceholder.jsx");

let Pagination =              require("./Pagination.jsx");

let CircuitsUtil =            require("../util/CircuitsUtil.js");
let ObservableUtil =            require("../util/ObservableUtil.js");
const { getNonEmptyQueryParams } =      require("../util/Utilities.js");

// TODO def get rid of inheritance
// TODO rename to CardContainer?
class ListDataContainer extends PaginationDataComponent {

    constructor() {
        super();
        this.changePage = this.changePage.bind(this);
        this.setReloadTimer = this.setReloadTimer.bind(this);
        this.checkMarkForDeleted = this.checkMarkForDeleted.bind(this);

        this.reloadTimer = null;
    }
    
    componentDidMount(){
        // this sets the data (TODO get rid of inheritance it is a bad solution for this!)
        super.componentDidMount() 

        ObservableUtil.subscribeToChange("delete", "all", "assetCard", (response, isError) => this.getData(this.getDataUrl(this.props), this.props.handleError));

    }

    componentWillUnmount() {
        ObservableUtil.unsubscribeToChange("delete", "all", "assetCard");

        clearTimeout(this.reloadTimer);
    }

    // find out what this means and if we need this
    shouldComponentUpdate(nextProps) {
        if(nextProps && nextProps.yieldRendering) {
            return false;
        } else {
            return true;
        }
    }

    // this logic will check the data whenever the component is going to update. 
    // if some of that data is tagged for removal (has been deleted/undeleted but still showing up in search)
    // set a timeout to refresh the data, because the data will be gone soon.
    componentWillUpdate(nextProps, nextState){
        let data = nextState ? nextState[PaginationDataComponent.dataField] : undefined;

        if(data){
            this.checkMarkForDeleted(data.results);
        }
    }

    checkMarkForDeleted(data){
        const { isTrash } = this.props;

        // if some of these cards on this page have been tagged for removal,
        // refresh the page after a few second delay
        if(data){
            if(CircuitsUtil.checkMarkForDeleted(data, isTrash)){
                this.setReloadTimer(1000);
            }
        }
    }

    setReloadTimer(time){
        clearTimeout(this.reloadTimer);
        this.reloadTimer = setTimeout(()=>{
            this.getData(this.getDataUrl(this.props), this.props.handleError)
        }, time);
    }


    render() {
        const { CardType: Card, onHandleImportFile, doingSearch, cssCardTag, layout, currentHub, showLoadingPlaceholder = true, dataUrl, page } = this.props;

        const nonEmptyQueryParams = getNonEmptyQueryParams(dataUrl);
        const isMoreQueryParams = nonEmptyQueryParams && nonEmptyQueryParams.size > 1;

        const hubDeleted = (currentHub)?currentHub.deleted : null;

        let data = this.state ? this.state[PaginationDataComponent.dataField] : undefined;
        if(!data) {
            return showLoadingPlaceholder ? <LoadingPlaceholder /> : null
        } else if(data && data.rows === 0 && page === 'explore') {
            return <p className="noResults">No results found.</p>;
        } else if(data && data.rows === 0 && isMoreQueryParams) {
            if(doingSearch) return null;
            return <p className="noResults">No results found.</p>;
        } else if(data && data.rows > 0) {
            return  <div>
                        <div className={`cards -${layout} -${cssCardTag}`}>
                            {
                                data.results.map(item =>  <Card 
                                    key={item.id}
                                    {...this.props}
                                    resource = {item}
                                    />)}
                        </div>
                        <Pagination pageSize={this.pageSize} total={data.numberOfResults} currentPage={data.start / this.pageSize} onPageChangeHandler={this.changePage} />
                    </div>
        } else if(data.error) {
            return null;
        } else if(!hubDeleted) {
            let EmptyCard = this.props.EmptyCard;
            return <EmptyCard onHandleImportFile={onHandleImportFile}/>
        }

        return null;
    };

}

module.exports = ListDataContainer;
